import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

import { RIBBON_CONTAINER_PADDING } from 'components/Ribbon/styles';

const styles = StyleSheet.create({
    root: {
        alignSelf: 'flex-start',
        marginLeft: RIBBON_CONTAINER_PADDING,
        marginTop: 40,
        flexDirection: 'row',
        alignItems: 'center',
    },
    loadingRoot: {
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        borderRadius: 32,
        width: 120,
    },
    textContainer: {
        display: 'flex',
    },
});

export default styles;
